﻿import {createAsyncStore} from "./async.store";
import {fetchProjectMeasurementMomentsAsc} from "../api/measurements.api";

export const measurementMomentsStore = createAsyncStore(
    fetchProjectMeasurementMomentsAsc
);